import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class RepositoryService {

  constructor(private http: HttpClient) { }

  public get(url: string, endpoint: string, responseType?: any, params?: any): Observable<any> {
    let reqParams: HttpParams = null;
    if (params) {
      reqParams = new  HttpParams();
      Object.keys(params).forEach(key => {
        reqParams.append(key, params[key]);
      });
    }
    return this.handleRequest('Get', url + endpoint, null, reqParams, null, responseType);
  }

  public post(url: string, endpoint: string, body: any, reqHeaders?: HttpHeaders, responseType?: any): Observable<any> {
    return this.handleRequest('Post', url + endpoint, body, null, reqHeaders, responseType);
  }

  public upload(url: string, endpoint: string, formData: any, reportProgress = false): Observable<any> {
    const httpObserve: any = reportProgress ? 'events' : 'response';
    const httpOptions  = {
      reportProgress,
      observe : httpObserve
    };

    return this.http.post(url + endpoint, formData, httpOptions);
  }

  public put(url: string, endpoint: string, body: any): Observable<any> {
    const httpObserve = 'response';
    const httpResponseType = 'json';
    const httpOptions  = {
      body,
      headers: new HttpHeaders(),
      responseType: httpResponseType,
      observe : httpObserve
    };
    return this.getHttpRequest('Put', url + endpoint, httpOptions);
  }

  public delete(url: string, endpoint: string, body: any): Observable<any> {
    const httpOptions  = {
      body,
    };
    return this.getHttpRequest('Delete', url + endpoint, httpOptions);
  }

  private handleRequest(method: string, url: string, reqBody?: any,
                        reqParams?: HttpParams, reqHeaders?: HttpHeaders, responseType?: any): Observable<any> {
    const httpObserve: any = 'response';
    const httpResponseType = responseType ? responseType : 'json';
    if (!reqHeaders) {
      reqHeaders =  new HttpHeaders();
    }
    if (reqHeaders.get('X-Set-Content-Type') === null) {
      reqHeaders = reqHeaders.set('Content-Type', 'application/json');
    }

    const httpOptions  = {
      body : reqBody,
      headers: reqHeaders,
      params: reqParams,
      responseType: httpResponseType,
      observe : httpObserve
    };

    return this.getHttpRequest(method, url, httpOptions);
  }

  private getHttpRequest(method: string, url: string, httpOptions: any): Observable<any> {
    return new Observable((observer) => {
      this.http.request(method, url, httpOptions)
        .subscribe(
        (response) => {
          const resBody = response['body'] !== null ? response['body'] : {};
          observer.next(resBody);
          observer.complete();
        }, (error) => { observer.error(error); });
      });
  }
}
